import React from "react";
import i18n from "i18next";

import { TooltipIcons } from "./Icons";

export const TooltipSeatDetail = (target: any, info: any, onSelect: any, handleClose?: any) => {
    const isTouch = !!onSelect;
    return (
        <div
            className={`wrapper_in_tooltip_seats ${isTouch ? 'is_mobile_modal' : ''}`}
            style={{ borderLeft: `4px solid ${target.category?.color ?? ""}` }}
        >
            {target.category && (
                <div
                    className="box_name_category"
                    style={{ color: target.category.color }}
                >
                    <p> {target.category.name}</p>
                </div>
            )}
            <TooltipIcons target={target} />

            <div className="box_details_seats">
                <p>
                    <span>
                        {i18n.t("tooltipSeat.section")}:{" "}
                        <strong>{target.sectionLabel || "?"}</strong>{" "}
                    </span>
                    &nbsp;
                </p>
                <p>
                    <span>
                        {i18n.t("tooltipSeat.row")}:{" "}
                        <strong>{target.rowLabel || "?"}</strong>
                    </span>
                    &nbsp; &nbsp;
                    <span>
                        {i18n.t("tooltipSeat.seat")}: <strong>{target.label || "?"}</strong>
                    </span>
                </p>
            </div>
            {
                target.status == "Booked" && <div className="box_info_seats"><span dangerouslySetInnerHTML={{ __html: info }} /></div>
            }
            {isTouch && handleClose && (
                <div className="box_handle_mnsj">
                    <div className="box_btns_modal">
                        <button className="btn_neutro for_close w-100" onClick={handleClose}>
                            Cerrar
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};
